module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-ko-KR.be14f80d.jpg";